import moment from "moment";

export function parseDate(dateString) {
  return moment(dateString).format("YYYY/MM/DD");
}

export function parseTime(dateString) {
  return moment(dateString).format("HH:mm");
}
